<div *ngIf="modalArguments" data-test-id="modal-role-select">
  <div class="modal-header">
    <h4 class="modal-title" data-test-id="modal-title-role-select">
      {{ 'INDIVIDUAL_MANAGE_ROLES_HINT' | translate }}
    </h4>
    <button
      type="button"
      class="unstyled-button"
      aria-label="Close"
      data-test-id="modal-role-select-btn-dismiss"
      (click)="onDismiss()"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
    </button>
  </div>
  <div class="modal-body" data-test-id="wrap-message-role">
    <p data-test-id="modal-title-role-hint">
      {{ 'INDIVIDUAL_ROLES_SELECTION_DIALOG_INSTRUCTION_HINT' | translate }}
    </p>
    <form>
      <div *ngFor="let role of roles; index as i" class="form-check spacing" [attr.data-test-id]="'wrap-checkbox-' + i">
        <input
          class="form-check-input"
          type="checkbox"
          [id]="'message-role-select-dialog-checkbox-' + i"
          [attr.data-test-id]="'message-role-select-dialog-checkbox-' + i"
          [formControl]="form.get(role.value)"
        />
        <label [for]="'message-role-select-dialog-checkbox-' + i" class="form-label">
          {{ role.label }}
        </label>
      </div>
    </form>
  </div>
  <div class="modal-footer" data-test-id="modal-role-select-footer">
    <button
      *ngFor="let button of modalArguments.buttons; index as i"
      [attr.type]="button.type || 'button'"
      class="btn"
      [ngClass]="button.class"
      (click)="actionsHandler(button.action)"
      [attr.data-test-id]="'message-role-select-dialog-btn-' + i"
      [disabled]="button.action === saveRolesChanges && isFormChange"
    >
      {{ button.text | translate }}
    </button>
  </div>
</div>
